export { default } from "./DeleteRequester";
export * from "./DeleteRequester";
